<template>
  <div v-if="!hidden">
    <section-title content="Información de Dirección Física" :has-line="true" />
    <location-service-addresses-row
      v-for="(address, idx) in items"
      :key="`type-${idx}`"
      :address="address"
      :data="data"
      :location-id="locationId"
      :municipalities="municipalities"
      @on-submit="onEditHandler"
    />

    <div v-if="items.length == 0" class="bg-secondary-3 rounded p-4 px-5">
      <custom-result-not-found
        :text="'No cuenta con la información de dirección en sistema.'"
      />
    </div>

    <div class="mt-3">
      <div v-if="showAddOrEdit" class="bg-secondary-3 rounded p-2">
        <address-form
          v-model="model"
          :address-types="addressTypes"
          class="bg-white"
          :is-provider-office="isProviderOffice"
          :municipalities="municipalities"
          :municipality-id="municipalityId"
          @cancel="cleanModel"
          @save="save"
        />
      </div>
      <!-- <div v-if="!showAddOrEdit" class="d-flex flex-row-reverse">
        <action-button
          i="fas fa-file-plus"
          text="Añadir"
          variant="success"
          @click="showAddressForm"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import AddressTypes from '@/utils/constants/addressTypes.js';
// import ActionButton from 'ActionButton';
import CustomResultNotFound from 'custom-result-not-found';
import AddressForm from './LocationServiceAddress.vue';
import LocationServiceAddressesRow from './LocationServiceAddressesRow.vue';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import {
  getAddressTypes as _getAddressTypes,
  addLocationAddress as _addLocationAddress,
} from '@/services/common/location.api.js';
import CodeLocationTypes from '@/utils/constants/codeLocationTypes';

export default {
  name: 'LocationServiceAddresses',
  components: {
    SectionTitle,
    // ActionButton,
    AddressForm,
    CustomResultNotFound,
    LocationServiceAddressesRow,
  },
  mixins: [alertMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    locationId: {
      type: Number,
      default: null,
    },
    municipalities: {
      type: Array,
      default: () => [],
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    isProviderOffice: {
      type: Boolean,
      default: () => false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showAddOrEdit: false,
      addressTypes: [],
      model: {
        id: null,
        addressTypeCd: null,
        addressTypeDescription: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        municipalityId:
          this.data.demographicInfo.locationTypeId ==
          CodeLocationTypes.ProviderOffice
            ? this.data.demographicInfo.municipalityId
            : null,
        municipalityDescription: null,
        zipCode: null,
        latitude: null,
        longitude: null,
        additionalAnnotations: null,
      },
    };
  },
  async mounted() {
    await Promise.all([this.getAddressTypes()]);
  },
  computed: {
    fullAddress() {
      return (item) => {
        const address = `${item.addressLine1 || ''} ${item.addressLine2 ||
          ''} ${item.addressLine3 || ''} ${item.municipalityDescription ||
          ''}`.trim();
        return `${address}, Puerto Rico ${item.zipCode}`;
      };
    },
    isPhysicalAddress() {
      return (item) => {
        return item.addressTypeCd === AddressTypes.Physical;
      };
    },
    actionItems() {
      return (item) => {
        return [
          {
            label: 'Editar',
            icon: 'fas fa-edit color-green',
            border: this.isPhysicalAddress(item) ? '' : 'bottom',
            click: () => this.showAddressForm(item),
          },
          {
            label: 'Eliminar',
            icon: 'fas fa-times-circle color-red',
            visible: !this.isPhysicalAddress(item),
            click: () => this.deleteLocationAddress(item),
          },
        ];
      };
    },
    dataModel() {
      return this.data;
    },
  },
  methods: {
    showAddressForm(item) {
      this.showAddOrEdit = true;
      if (item) this.model = item;
    },
    async getAddressTypes() {
      const { data } = await _getAddressTypes();
      this.addressTypes = data;
    },
    async save() {
      await this.addLocationAddress();
      this.cleanModel();
    },
    async addLocationAddress() {
      const payload = { ...this.model, locationId: this.locationId };
      const { data } = await _addLocationAddress(payload).catch((error) => {
        const message = error?.response?.data?.message ?? error.message;
        this.ShowToast('Alerta', `${message}.`, 'error');
        return { data: false };
      });

      if (data) {
        this.ShowToast(
          `Confirmación`,
          'La dirección ha sido añadida exitosamente.',
          'success'
        );
        this.$emit('reload');
      }
    },
    async onEditHandler() {
      this.$emit('reload');
    },
    cleanModel() {
      this.showAddOrEdit = false;
      this.model = {
        id: null,
        addressTypeCd: null,
        addressTypeDescription: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        municipalityId: null,
        municipalityDescription: null,
        zipCode: null,
        latitude: null,
        longitude: null,
        additionalAnnotations: null,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.dot {
  background-color: map-get($colors, 'orange');
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: map-get($colors, 'white');
  display: inline-block;
}

.custom-col-sm-5 {
  flex: 0 0 41.66666667%;
  max-width: 37.9%;
}

@media screen and (max-width: 768px) {
  .mobile-only {
    display: block;
  }
  .mt-sm-n5 {
    margin-top: 0 !important;
  }
  .ml-sm-n4 {
    margin-left: 0 !important;
  }
}
</style>
